"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getItem = exports.createItem = exports.updateItem = exports.useTemplates = exports.useExportDesignProviders = exports.useExportDataProviders = exports.useExportTypes = exports.useAllowdExportTypes = exports.useExportRequestStates = void 0;
const react_1 = require("react");
const crud_source_hook_1 = require("../../utils/crud-source-hook");
const list_source_hook_1 = require("../../utils/list-source-hook");
const export_context_1 = require("./export-context");
const export_types_1 = require("./export-types");
function useExportRequestStates() {
    return (0, list_source_hook_1.useStaticListSource)([
        { id: 'PENDING', name: 'Čekající' },
        { id: 'PROCESSING', name: 'Zpracováva se' },
        { id: 'PROCESSED', name: 'Ukončen' },
        { id: 'FAILED', name: 'Ukončen s chybu' },
    ]);
}
exports.useExportRequestStates = useExportRequestStates;
function useAllowdExportTypes(allowedTypes) {
    const items = [
        { id: 'DOCX', name: 'Dokument Word (docx)' },
        { id: 'XLSX', name: 'Sešit (xlsx)' },
        { id: 'PDF', name: 'Dokument PDF (pdf)' },
        { id: 'HTML', name: 'Stránka (html)' },
        { id: 'XML', name: 'Datový soubor (xml)' },
        { id: 'CSV', name: 'Datový soubor (csv)' },
    ];
    return (0, list_source_hook_1.useStaticListSource)(items.filter((item) => allowedTypes === null || allowedTypes === void 0 ? void 0 : allowedTypes.includes(item.id)));
}
exports.useAllowdExportTypes = useAllowdExportTypes;
function useExportTypes(designProvider) {
    let data;
    if (designProvider == null) {
        data = [];
    }
    else if (designProvider === export_types_1.ExportDesignProvider.DOCX_PROVIDER) {
        data = [
            { id: 'DOCX', name: 'Dokument Word (docx)' },
            { id: 'PDF', name: 'Dokument PDF (pdf)' },
        ];
    }
    else {
        data = [
            { id: 'DOCX', name: 'Dokument Word (docx)' },
            { id: 'XLSX', name: 'Sešit (xlsx)' },
            { id: 'PDF', name: 'Dokument PDF (pdf)' },
            { id: 'HTML', name: 'Stránka (html)' },
            { id: 'XML', name: 'Datový soubor (xml)' },
            { id: 'CSV', name: 'Datový soubor (csv)' },
        ];
    }
    return (0, list_source_hook_1.useStaticListSource)(data);
}
exports.useExportTypes = useExportTypes;
function useExportDataProviders() {
    return (0, list_source_hook_1.useStaticListSource)([
        { id: 'CONFIGURATION_PROVIDER', name: 'EAS Configuration data provider' },
        { id: 'NOOP_PROVIDER', name: 'No-op provider' },
        { id: 'PARAMS_PROVIDER', name: 'EAS Params provider' },
        { id: 'BATCHED_PARAMS_PROVIDER', name: 'EAS Batched Params provider' },
        { id: 'REPORTING_PROVIDER', name: 'EAS Reporting provider' },
        { id: 'SINGLE_ENTITY_PROVIDER', name: 'EAS Single entity provider' },
    ]);
}
exports.useExportDataProviders = useExportDataProviders;
function useExportDesignProviders(enableDocx4j = true) {
    const data = [
        { id: 'DYNAMIC_PROVIDER', name: 'Dynamic grid design provider' },
        { id: 'SIMPLE_PROVIDER', name: 'Simple design provider' },
    ];
    if (enableDocx4j) {
        data.push({ id: 'DOCX_PROVIDER', name: 'Simple docx4j design provider' });
    }
    return (0, list_source_hook_1.useStaticListSource)(data);
}
exports.useExportDesignProviders = useExportDesignProviders;
function useTemplates(tag) {
    const { url } = (0, react_1.useContext)(export_context_1.ExportContext);
    return (0, list_source_hook_1.useListSource)({
        url: `${url}/templates/tagged/${tag}`,
    });
}
exports.useTemplates = useTemplates;
function embedDocx4jscript(template) {
    var _a;
    if (template.docx4jscript != null && template.docx4jscript != '') {
        const configuration = JSON.parse((_a = template.configuration) !== null && _a !== void 0 ? _a : '{}');
        configuration['docx4jscript'] = template.docx4jscript;
        template.configuration = JSON.stringify(configuration);
    }
}
exports.updateItem = (0, crud_source_hook_1.updateItemFactory)({
    preProcess: (template) => {
        embedDocx4jscript(template);
        return template;
    },
});
exports.createItem = (0, crud_source_hook_1.createItemFactory)({
    preProcess: (template) => {
        embedDocx4jscript(template);
        return template;
    },
});
exports.getItem = (0, crud_source_hook_1.getItemFactory)({
    postProcess: (template) => {
        try {
            const configuration = JSON.parse(template.configuration);
            template.docx4jscript = configuration['docx4jscript'];
        }
        catch (e) {
            // do nothing
        }
        return template;
    },
});
//# sourceMappingURL=export-api.js.map